import React, { useEffect, useState } from 'react'
import ProspectsList from '../ProspectsList'
import ProspectsTabs from '../ProspectsTabs/ProspectsTabs'
import { WrapperProspects } from './ProspectsContainer.styles'
import Main from 'src/components/common/Main/Main'
import { GridContainer, GridItem } from 'src/components/common/grids'
import { useAppDispatch } from 'src/hooks/redux'
import { loadProspectCatalogs } from 'src/redux/prospects/prospects.thunks'

const ProspectsContainer = () => {
    const [initialized, setInitialized] = useState(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (initialized) {
            dispatch(loadProspectCatalogs())
            return;
        }
        setInitialized(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialized]);
    return (
        <Main>
            <WrapperProspects>
                <GridContainer p-sm="0" ggap-lg="80px" >
                    <GridItem lg={11}>
                        <ProspectsTabs />
                    </GridItem>
                    {/* <GridItem lg={3}>
                        <ProspectsSearcher />
                    </GridItem> */}
                </GridContainer>
                <ProspectsList />
            </WrapperProspects>
        </Main>
    )
}

export default ProspectsContainer